export const ACTION_PREFIX = 'MODULE/ROOM_PLAN'
